import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import ToastUGNX from "../ToastsAndAlerts/ToastUGNX";
import styled, { withTheme } from "styled-components";
import { ToastOptions } from "./constants";
import CryptoJS from "crypto-js";
import i18next from "i18next";
import { isRtl } from "../../i18n/helpers";

const StyledContainer = styled(ToastContainer)`
  .Toastify__toast {
    padding: 0px;
    box-shadow: none;
  }
  .Toastify__toast--default {
    color: ${(props) => props.theme.nero};
  }
  .Toastify__toast-body > div {
    width: 100%;
  }
`;

const titleObj = {
  Success: "appText.success",
  Error: "appText.error",
  Warning: "appText.warning",
};

export const sendNotification = (
  message,
  type,
  countDown = ToastOptions.countDown
) => {
  const title = i18next.t(titleObj[type]);
  const toastPosition = isRtl()
    ? toast.POSITION.BOTTOM_RIGHT
    : toast.POSITION.BOTTOM_LEFT;

  message &&
    toast(
      <ToastUGNX
        {...{ type }}
        {...{ title }}
        isRtl={isRtl()}
        countDown={countDown}
      >
        {String(message)}
      </ToastUGNX>,
      {
        ...ToastOptions,
        toastId: CryptoJS.MD5(message).toString(),
        position: toastPosition,
        autoClose: countDown * 1000,
      }
    );
};

const ToastManager = (props) => {
  return <StyledContainer {...props} />;
};

export default withTheme(ToastManager);
